<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Cloud Off" class="d-icon d-icon--cloud-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"><path d="M4.505 2.463a.5.5 0 0 1 .567-.423A4.004 4.004 0 0 1 8.209 4.5h.54a2.75 2.75 0 0 1 2.465 3.972.5.5 0 1 1-.896-.444A1.75 1.75 0 0 0 8.75 5.5h-.895a.5.5 0 0 1-.48-.357A3.004 3.004 0 0 0 4.929 3.03a.5.5 0 0 1-.423-.567ZM.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-1.398-1.4A2.683 2.683 0 0 1 8.75 10H4.5a4 4 0 0 1-2.405-7.198L.646 1.354a.5.5 0 0 1 0-.708Zm.938 6.064a3 3 0 0 1 1.228-3.191L8.292 9H4.5a3 3 0 0 1-2.916-2.29Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCloudOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
